export default "__VITE_ASSET__miXeOy6B__"